import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MainService } from 'src/app/app.service';
import { SmartReviewApiService } from './smart-review-api.service';
import { SmartReviewJob, SmartReviewJobsResponse, SmartReviewPromptType } from '../interfaces/job.interface';

/** Jobs de processamento do Smart Review: listagem, status e retry. */
@Injectable()
export class JobsService extends SmartReviewApiService {
  constructor(http: HttpClient, mainService: MainService) {
    super(http, mainService);
  }

  getJobs(filters?: {
    promptType?: SmartReviewPromptType;
    resourceId?: string;
    jobType?: string;
    limit?: number;
    offset?: number;
  }): Observable<SmartReviewJobsResponse<SmartReviewJob>> {
    let params = new HttpParams();
    if (filters?.promptType) {
      params = params.set('promptType', filters.promptType);
    }
    if (filters?.resourceId) {
      params = params.set('resourceId', filters.resourceId);
    }
    if (filters?.jobType) {
      params = params.set('jobType', filters.jobType);
    }
    if (filters?.limit != null) {
      params = params.set('limit', String(filters.limit));
    }
    if (filters?.offset != null) {
      params = params.set('offset', String(filters.offset));
    }

    return this.http
      .get<SmartReviewJobsResponse<SmartReviewJob>>(`${this.apiURL}/jobs`, {
        headers: this.jsonHeaders,
        params
      })
      .pipe(catchError(this.mainService.handleError));
  }

  getJobStatus(jobId: string): Observable<SmartReviewJob> {
    return this.http
      .get<SmartReviewJob>(`${this.apiURL}/jobs/${jobId}`, { headers: this.jsonHeaders })
      .pipe(catchError(this.mainService.handleError));
  }

  retryJob(jobId: string, rerunMode: 'all' | 'missing' = 'all'): Observable<{ jobId?: string; id?: string }> {
    return this.http
      .post<{ jobId?: string; id?: string }>(
        `${this.apiURL}/jobs/${jobId}/retry`,
        { rerunMode },
        { headers: this.jsonHeaders }
      );
  }
}
